/* eslint-disable eqeqeq */
/* eslint-disable max-len */
import { Component, OnInit, ViewChild } from '@angular/core';
import { GridOptions, ValueGetterParams } from "ag-grid-community";
import { PointStoreProductOrderService } from '../../services/point-store-product-order.service';
import { ShoppingCartService } from '../../services/shopping-cart.service';
import { AgGridHelperService } from 'src/app/reusables/services/ag-grid-helper.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { DatePipe } from '@angular/common';
import { ReorderBtnRenderedComponent } from '../../custom-renders/reorder-btn-rendered/reorder-btn-rendered.component';
import { CvNumberLocalizePipe } from 'src/app/reusables/pipes/cv-number-localize.pipe';
import { AgGridAngular } from 'ag-grid-angular';

@Component({
    selector: 'agent-order-history',
    templateUrl: './agent-order-history.component.html',
    styleUrls: ['./agent-order-history.component.scss']
})
export class AgentOrderHistoryComponent implements OnInit {
    @ViewChild('agentOrderHistoryGrid') agGrid: AgGridAngular;

    pspos: any = null;
    pscs: any = null;
    _data: any = null;
    _localizationStrings = new Map();
    filterValue = ""; // This variable contains the contents of the search bar.
    showFilter = false;
    gridOptions: GridOptions = null;
    statusIncludes = [];
    components: any;

    constructor(
        private pointStoreProductOrderService: PointStoreProductOrderService,
        private shoppingCartService: ShoppingCartService,
        private agGridHelperService: AgGridHelperService,
        private cvLocalizationService: CVLocalizationService,
        private datePipe: DatePipe,
        private cvNumberLocalize: CvNumberLocalizePipe
    ) {
        this.pspos = pointStoreProductOrderService.pointStoreProductOrderObj;
        this.pscs = shoppingCartService.shoppingCartObj;
        this.components = {
            buttonRenderer: ReorderBtnRenderedComponent
        };
    }

    ngOnInit(): void {
        // this.pointStoreProductOrderService.loadOrderStatusName();
        // this.pointStoreProductOrderService.LoadPointStoreProductHistoryOrders();

        // if (this.pspos.historyOrders != null) {
        //   this.loadLocalizations();
        //   this.loadData();
        // }
        // else {
        //   setTimeout(() => {
        //     this.ngOnInit();
        //   }, 500);
        // }

        //Improve multiple requests
        this.loadServiceApis();

    }

    async loadServiceApis() {
        await this.pointStoreProductOrderService.loadOrderStatusName();
        await this.pointStoreProductOrderService.LoadPointStoreProductHistoryOrders();
        this.loadLocalizations();
        this.loadData();
    }

    loadData() {
        this._data = this.pspos.historyOrders;
        if (this._data != null && this.gridOptions && this.agGrid?.api) {
            this.agGrid?.api.setGridOption('rowData', this._data);
        } // else, the grid's onGridReady() event handler should load up its initial values.
        else {
            setTimeout(() => {
                this.loadData();
            }, 500);
        }
    }

    loadLocalizations() {
        this.cvLocalizationService.GetSection("MarketPlace").then((map) => {
            this._localizationStrings = map;
        }).finally(() => {
            this.setupGrid();
        });
    }

    getLocalizationString(key, defaultValue) {
        if (this._localizationStrings && this._localizationStrings.has(key))
            return this._localizationStrings.get(key);
        return defaultValue;
    }

    setupGrid() {
        this.gridOptions = this.agGridHelperService.createGridOptions({
            rowHeight: 40,
            getRowStyle: (params) => {
                if (params.node.expanded)
                    return { background: '#B7E4FF' };
            },
            suppressCellFocus: true,
            suppressRowClickSelection: true,
            suppressContextMenu: true,
            overlayNoRowsTemplate: `
                <div style="text-align:center;">
                    <span style="font-size:18px; font-weight: bold; color: #6A7480; margin-bottom: 8px;">${this.getLocalizationString("No_Orders", "No orders yet!")}</span> <br>
                    <span style="font-size:14px; color: #A8AFB9; margin-bottom: 8px; line-height: 3;">${this.getLocalizationString("No_Orders_Message", "Looks like you haven't placed any orders yet. This is where they will appear when you do")}</span>
                </div>
                `,
            suppressDragLeaveHidesColumns: true,
            defaultColDef: {
                sortable: true,
                filter: true,
                resizable: true,
                width: 200,
            },
            columnDefs: [
                {
                    field: "PointStoreOrderID",
                    colId: "PointStoreOrderID",
                    headerName: this.getLocalizationString("Order", "Order"),
                    width: 50,
                    filter: "agNumberColumnFilter",
                    sort: 'desc',
                    cellRenderer: 'agGroupCellRenderer',
                    cellClass: 'cell-vertical-align cell-orderid',
                },
                {
                    field: 'DateOrdered',
                    width: 60,
                    headerName: this.getLocalizationString("Date", "Date"),
                    valueFormatter: (params) => this.datePipe.transform(params.value, CVAngularDateFormat),
                    cellClass: 'cell-vertical-align color-whaleTail',
                },
                {
                    field: 'OrderTotal',
                    headerName: this.getLocalizationString("Total", "Total"),
                    width: 80,
                    filter: 'agNumberColumnFilter',
                    cellClass: 'cell-vertical-align color-whaleTail',
                    // eslint-disable-next-line max-len
                    valueFormatter: (params) => this.getPointStoreProductOrderValueCoins(params.value, params.data.ProductsCollection[0]._PointStoreProductOrderedDTO.OrderOrigin)
                },
                {
                    headerName: this.getLocalizationString("Status", "Status"),
                    valueGetter: (params) => {
                        if (this._data != null)
                            return this.pointStoreProductOrderService.getOrderStatusName(params.data.OrderStatus);
                        else
                            return 0;
                    },
                    width: 80,
                    cellClass: 'cell-vertical-align color-whaleTail',
                },
                {
                    field: 'Note',
                    headerName: this.getLocalizationString("Notes", "Notes"),
                    filter: "agTextColumnFilter",
                    cellClass: 'cell-vertical-align color-whaleTail',
                },
            ],
            masterDetail: true,
            detailRowAutoHeight: true,
            detailCellRendererParams: {
                detailGridOptions: {
                    rowHeight: 126,
                    localeText: { noRowsToShow: "No Products Found" },
                    rowSelection: 'multiple',
                    rowMultiSelectWithClick: true,
                    suppressCellFocus: true,
                    suppressRowClickSelection: true,
                    suppressContextMenu: true,
                    suppressDragLeaveHidesColumns: true,
                    components: this.components,
                    defaultColDef: {
                        sortable: true,
                        filter: true,
                        resizable: true,
                        width: 200,
                    },
                    columnDefs: [
                        {
                            //Product Image
                            cellRenderer: (params) => {
                                if (params.data != null) {
                                    const imgContainer = $('<div>').addClass('orders-imgContainer');
                                    const img = document.createElement('img');
                                    if (params.data._PointStoreProductOrderedDTO.Variation != null && params.data._PointStoreProductOrderedDTO.Variation > 0) {
                                        const matchedProduct = this.pscs.pointStoreProducts.find((p) => p.PointStoreProductID == params.data._PointStoreProductOrderedDTO.PointStoreProductID);
                                        if (matchedProduct != null) {
                                            if (matchedProduct.HasMultipleImages && matchedProduct.MultipleImagesData != null) {
                                                const variationImageData = matchedProduct.MultipleImagesData.find((mp) => mp.PointStoreProductVariationID == params.data._PointStoreProductOrderedDTO.Variation);
                                                if (variationImageData != null && variationImageData.PointStoreProductImageID != null && variationImageData.PointStoreProductImageID > 0)
                                                    img.src = params.data._PointStoreProductOrderedDTO.ProductImageID == 0 ? '../Admin/ImageResizer.aspx?imgid=-16&w=auto&h=80' : '../Admin/ImageResizer.aspx?imgid=' + variationImageData.PointStoreProductImageID + '&w=auto&h=200';
                                                else
                                                    img.src = params.data._PointStoreProductOrderedDTO.ProductImageID == 0 ? '../Admin/ImageResizer.aspx?imgid=-16&w=auto&h=80' : '../Admin/ImageResizer.aspx?imgid=' + params.data._PointStoreProductOrderedDTO.ProductImageID + '&w=auto&h=200';
                                            } else
                                                img.src = params.data._PointStoreProductOrderedDTO.ProductImageID == 0 ? '../Admin/ImageResizer.aspx?imgid=-16&w=auto&h=80' : '../Admin/ImageResizer.aspx?imgid=' + params.data._PointStoreProductOrderedDTO.ProductImageID + '&w=auto&h=200';
                                        }
                                        else
                                            img.src = params.data._PointStoreProductOrderedDTO.ProductImageID == 0 ? '../Admin/ImageResizer.aspx?imgid=-16&w=auto&h=80' : '../Admin/ImageResizer.aspx?imgid=' + params.data._PointStoreProductOrderedDTO.ProductImageID + '&w=auto&h=200';
                                    } else
                                        img.src = params.data._PointStoreProductOrderedDTO.ProductImageID == 0 ? '../Admin/ImageResizer.aspx?imgid=-16&w=auto&h=80' : '../Admin/ImageResizer.aspx?imgid=' + params.data._PointStoreProductOrderedDTO.ProductImageID + '&w=auto&h=200';
                                    $(img).addClass('cart-product-image').appendTo(imgContainer);
                                    return imgContainer[0];
                                }
                            },
                        },
                        {
                            //Order details
                            cellRenderer: (params) => {
                                if (params.data._PointStoreProductOrderedDTO != null) {
                                    const productDetailsContainer = $('<div>').addClass('orders-detailContainer');
                                    const variationName = params.data._PointStoreProductOrderedDTO.VariationName != null && params.data._PointStoreProductOrderedDTO.VariationName != '' ? params.data._PointStoreProductOrderedDTO.VariationName : 'N/A';
                                    productDetailsContainer.append(`
                                        <span><b>${this.getLocalizationString("Product", "Product")}: </b>${params.data._PointStoreProductOrderedDTO.Title}</span><br/>
                                        <span><b>${this.getLocalizationString("testing", "Variation")}: </b>${variationName}</span><br/>
                                        <span><b>${this.getLocalizationString("Quantity_Ordered", "Quantity Ordered")}: </b>${params.data._PointStoreProductOrderedDTO.ProductQuantity}</span><br/>
                                        <span><b>${this.getLocalizationString("Price_per_Unit", "Price per unit")}: </b>${this.getPointStoreProductOrderValueCoins(params.data._PointStoreProductOrderedDTO.ProductCost, params.data._PointStoreProductOrderedDTO.OrderOrigin)}</span>
                                        `);
                                    let icon = '';
                                    const productIndex = this.pscs.pointStoreProducts.findIndex((elem) => elem.PointStoreProductID == params.data._PointStoreProductOrderedDTO.PointStoreProductID);
                                    if (productIndex > -1 && params.data._PointStoreProductOrderedDTO.ProductCost != this.pscs.pointStoreProducts[productIndex].Price)
                                        icon = `<div title="${this.getLocalizationString("Ordered_On_Sale", "This Item was ordered while on sale, if reordered the current price will apply.")}" style="display: inline-block;"><svg class="icon-16 fill-cerulean" style="margin-left: 16px;"><use href="../App_Themes/clearview-default/icons/utility/support.svg#support"></use></svg></div>`;
                                    $(icon).appendTo(productDetailsContainer);
                                    return productDetailsContainer[0];
                                }
                            },
                            width: 250,
                        },
                        {
                            cellRenderer: 'buttonRenderer',
                        },
                        { flex: 1 },
                    ],
                },
                getDetailRowData: (params) => {
                    params.successCallback(params.data.ProductsCollection);
                },
            },
            onRowGroupOpened: (params) => {
                this.agGrid?.api.redrawRows({
                    rowNodes: [params.node]
                });
            },
            onRowClicked: (params) => {
                params.node.setExpanded(!params.node.expanded);
            },
            onGridReady: (params) => {
                if (this._data != this.pspos.historyOrders)
                    this._data = this.pspos.historyOrders;
                if (this._data) {
                    params.api.setGridOption('rowData', this._data);
                }
                if (this._data != null && this._data.length > 0) {
                    params.api.hideOverlay();
                } else {
                    this.gridOptions.noRowsOverlayComponent = null;
                    params.api.showNoRowsOverlay();
                }
                params.api.sizeColumnsToFit();
            },
            // This function defines which field from the row data is the "primary key".  It's used for delta updates between different setRowData() calls.
            getRowId: ({data: rowData}) =>
                rowData.PointStoreOrderID // This "ID" property is the same as the above columnDef.  Usually it'll be a group id.  If there is no "primary key" for the data you're trying to display, set deltaRowDataMode to false above.
            ,
            // The filter can also be set with the setQuickFilter() api call on the grid.
            //isExternalFilterPresent: function () { // External Filter refers to our search bar.  This function returns true when ctrl.filterValue has content, false when otherwise.  False causes ag-grid to show all row values.
            //    return ctrl.evtGlCtrl.searchTerm.length > 0;
            //},
            //doesExternalFilterPass: function (node) { // This function actually uses the value of the search bar, and it compares it to the data of the row ag-grid is passing in (node).  Use AgGridHelperService's unless you have good reason.
            //    return AgGridHelperService.doesExternalFilterPass(node, ctrl.evtGlCtrl.searchTerm);
            //},
            onSortChanged: (event) => {
                //queueStateSave();
                event.api.sizeColumnsToFit();
            },
            onColumnMoved: (event) => {
                //queueStateSave();
                event.api.sizeColumnsToFit();
            },
            onColumnPinned: (event) => {
                //queueStateSave();
                event.api.sizeColumnsToFit();
            },
            onColumnVisible: (event) => {
                event.api.sizeColumnsToFit();
                //queueStateSave();
            },
            onGridSizeChanged: (event) => {
                event.api.sizeColumnsToFit();
            },
            onRowSelected: this.onRowSelected
        });
    }

    onRowSelected(event) {
        event.node.data.IsChecked = event.node.isSelected();
    }

    callgetStatusName(params: ValueGetterParams) {
        if (this._data != null)
            return this.pointStoreProductOrderService.getOrderStatusName(params.data.OrderStatus);
        else
            return 0;
    }

    getPointStoreProductOrderValueCoins(coins, origin) {
        return (coins > 0) ? this.cvNumberLocalize.transform(coins) + ' ' + this.getLocalizationString("Coins", "Coins") : this.getGameName(origin);
    };

    getGameName(gameType): string {
        let gameName = '';

        switch (gameType) {
            case 9:
                gameName = this.getLocalizationString('Raffle', 'Raffle');
                break;
            case 10:
                gameName = this.getLocalizationString('Bracket_Tournament', 'Brackets Tournament');
                break;
        }
        return gameName;
    }

    allowBuyAgain(itemID, variation) {
        //Verify that the item still exists.
        //  If it does and has a quantity > 0 (or a quantity that isn't null), return true.
        const filteredItems = this.pscs.pointStoreProducts.filter(e => e.PointStoreProductID == itemID);
        let matchedItem = null;
        const dateToday = new Date();
        let dateCheck = false;
        let matchedVariation = null;

        if (filteredItems.length > 0) {
            matchedItem = filteredItems[0];

            //Check if date availability (eg, seasonal items) is valid.
            //  Date must be at or after the current date and before the end date (if no end date given, it's a forever-available-item)
            //  A null date indicates no explicit end date.
            if (new Date(matchedItem.ProductStart) <= dateToday && (matchedItem.ProductEnd == null || new Date(matchedItem.ProductEnd) > dateToday))
                dateCheck = true;
        } else {
            return false; //No items matched
        }

        if (matchedItem != null && matchedItem.HasProductVariations && matchedItem.VariationsData.length) {
            matchedVariation = matchedItem.VariationsData.find((v) => v.PointStoreProductVariationID == variation);
            if (matchedVariation == null)
                return false;
        }

        return matchedVariation != null ? ((matchedVariation.VariationQuantity == null || matchedVariation.VariationQuantity > 0) && dateCheck) : ((matchedItem.Quantity == null || matchedItem.Quantity > 0) && dateCheck);
    };

}
